<template>

    <div>
        <van-divider />
        <van-row >
            <van-col span="17" offset="1">
                <span style="color: #969799">支出￥{{pay}} 收入￥{{income}}</span>
            </van-col>
            <van-col span="6" >
                <van-button icon="calender-o" plain type="info" size="small" :text="qryDate" @click="showDatePicker = true" color="#fe7844"></van-button>

            </van-col>
        </van-row>
        <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker
                    v-model="pickDate"
                    type="year-month"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @cancel="showDatePicker = false"
                    @confirm="onDateConfirm"
            />
        </van-popup>
        <van-divider />
        <fin-month-count @getParData="getParData($event)" :search-date="qryDate"  view-id="monthCountId"></fin-month-count>
        <fin-month-sort @getParData="getSortData($event)" :search-date="qryDate" view-id="monthSortId"></fin-month-sort>
        <van-popup v-model="popupShow" round closeable position="bottom" :style="{ width: '100%',height: '80%' }" >
            <popup-fin-list :qry-data="qryData" :refresh-index="refreshIndex"></popup-fin-list>
        </van-popup>
        <div style="margin-bottom: 100px"></div>
    </div>
</template>

<script>
    import FinMonthCount from "./FinMonthCount";
    import FinMonthSort from "./FinMonthSort";
    import PopupFinList from "../report/PopupFinList";
    import * as DateUtil from '@/common/utils/dateUtil.js'
    import * as MyApi from '@/api/URLApiAddr.js'

    export default {
        name: "FinMonthStatistics",
        components: {
            FinMonthCount,
            FinMonthSort,
            PopupFinList
        },
        data() {
            return {
                qryDate: DateUtil.formatDate(new Date(),'yyyy-MM'),

                pickDate:new Date(),
                showDatePicker:false,
                minDate: DateUtil.getMinDate(),
                maxDate: DateUtil.getMaxDate(),
                income: 0,
                pay: 0,
                popupShow: false,
                refreshIndex: 0,
                qryData:{

                }
            }
        },
        watch:{
            qryDate() {
                this.qryMonthInfo()
            }

        },
        mounted(){
            this.qryMonthInfo()
        },
        methods: {
            qryMonthInfo() {
                let params = {month:this.qryDate}
                this.$axios.post(MyApi.QRY_FIN_MONTH_INFO,params/*,options*/)
                    .then((data) =>  {
                        //let data = response.data
                        if('200' == data.code){
                            let resData = data.data
                            if(resData){
                                this.income = resData.income
                                this.pay = resData.pay
                            }else{
                                this.income = 0
                                this.pay = 0
                            }
                        }

                    })
                    .catch((err) => {

                    })


            },
            onDateConfirm(value) {
                debugger
                this.qryDate = DateUtil.formatDate(value,'yyyy-MM');
                this.showDatePicker = false;
            },
            getParData(childData){
                debugger
                this.qryData = {}
                if(childData.belong){

                    this.qryData.belongs = [childData.belong]
                }
                this.qryData.month = this.qryDate
                this.qryData.finType = childData.finType
                if(childData.sort){
                    this.qryData.sorts = [childData.sort]
                    this.qryData.sort = childData.sort
                }
                //明细统计获取的值
                if(childData.detail){
                    this.qryData.details = [childData.detail]
                }
                if(childData.sortDetail){
                    this.qryData.sortDetail = childData.sortDetail
                }
                this.refreshIndex ++
                this.popupShow = true

            },
            getSortData(childData){
                debugger
                this.qryData = {}

                this.qryData.month = this.qryDate
                this.qryData.finType = childData.finType
                this.qryData.sortName = childData.sortName
                if(childData.sort){
                    this.qryData.sort = childData.sort
                }
                if(childData.detail){
                    this.qryData.details = [childData.detail]
                }
                if(childData.sortDetail || childData.detail){
                    this.refreshIndex ++
                    this.popupShow = true
                }
            },
            getDetailData(childData){
                //明细统计获取的值
                if(childData.detail){
                    this.qryData.details = [childData.detail]
                }
                this.refreshIndex ++
                this.popupShow = true
            }
        }
    }
</script>

<style scoped>

</style>
